import React from 'react';
import { identity, pickBy } from 'lodash';
import queryString from 'query-string';

import GetTours from '@src/api/GetTours';
import { generateTourSummery } from '@src/factories';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useFlatList from '@src/hooks/useFlatList';
import { TourSummery } from '@src/types';

const useSearchTour = (key: string, regionCode?: string) => {
  const axiosRequestConfig = useAxiosRequestConfig();

  const makeRequest = React.useCallback(
    async (offset: number, limit: number): Promise<TourSummery[]> => {
      if (!key) {
        return [];
      }
      const response = await GetTours(
        offset,
        limit,
        queryString.stringify(pickBy({ regionCode, key }, identity)),
        axiosRequestConfig
      );
      return response.data.tours.map((tour) => generateTourSummery(tour));
    },
    [axiosRequestConfig, key, regionCode]
  );

  return useFlatList(makeRequest);
};

export default useSearchTour;
